export default __webpack_public_path__ + "static/media/Casco.d95d17ef.jpg";